type Props = {
  isActiveBar: boolean
}

export const ActiveBar = ({ isActiveBar }: Props) => {
  return (
    <div className="flex items-center gap-1">
      <div
        className={`h-[2px] rounded-full transition-all duration-500 ${
          isActiveBar ? 'bg-primary dark:bg-primary-dark w-[36px]' : 'bg-card-border w-[20px]'
        }`}
      ></div>
      <div
        className={`h-[2px] rounded-full transition-all duration-500 ${
          !isActiveBar ? 'bg-primary dark:bg-primary-dark w-[36px]' : 'bg-card-border w-[20px]'
        }`}
      ></div>
    </div>
  )
}
